<ng-container *ngFor="let item of itemList; let index = index">
	<div class="input-group" *ngIf="selections[index]">
		<input
			type="text"
			class="form-control"
			[value]="labelGetter(item)"
			readonly />
		<div class="input-group-addon">
			<a class="" href="#" onclick="return false;" title="Retirer" (click)="onDeselectItem(index)">
				<span class="fa fa-minus-circle fa-lg"></span>
			</a>
		</div>
	</div>
</ng-container>
<div>
	<div class="input-group" *ngIf="showSelect">
		<input [id]="id" [name]="id"
			type="text"
			class="form-control"
			#input="matAutocompleteTrigger"
			[formControl]="filterInput"
			[matAutocomplete]="dropdownlist"
			[matAutocompletePosition]="'below'"
			(focus)="onInputFocus()"
			(blur)="onInputBlur()"
			(click)="onInputClick()"
			(keyup)="onInputKeyUp($event)"
			/>
		<mat-autocomplete 
			#dropdownlist="matAutocomplete"
			[displayWith]="getLabel"
			(optionSelected)="onOptionSelected($event)"
			panelWidth="auto" 
			>
			
			<mat-option
				*ngFor="let item of filteredItems | async"
				[value]="item"
				>
	
				{{ labelGetter(item.entity) }}
			</mat-option>
		</mat-autocomplete>

		<div class="input-group-addon">
			<a class="" href="#" onclick="return false;" title="Ajouter">
				<span class="fa fa-plus-circle fa-lg"></span>
			</a>
		</div>
	</div>
</div>
<div class="text-center">
	<a href="#" onclick="return false;" (click)="onSelectAll()">Tout ajouter</a>
	<span>&nbsp;/&nbsp;</span>
	<a href="#" onclick="return false;" (click)="onDeselectAll()">Tout retirer</a>
</div>
